import * as common from './common';
import { bundleConfig as bundleConfigDev } from './stage';

const host = 'https://local.minecraft.net';
export * from './dev';

export const sharedEnvConfig = (window.sharedEnvConfig = {
  ...window.sharedEnvConfig,
  'cookie.options': {
    domain: '',
    secure: false
  },
  reCaptcha: {
    sitekey: '6Le5MSUUAAAAAIOCO_bE8nauOv7u5an5sy0vtcJE'
  },
  'endpoint.minecraftServices': `${host}/`
});

export const msaMigrationConfig = (window.msaMigrationConfig = {
  ...common.msaMigrationConfig,
  ...window.msaMigrationConfig,
  'url.xboxUpsellReturnUrl': 'http://127.0.0.1/minecrafttest',
  'url.xboxLoginReturnUrl': 'http://127.0.0.1/minecrafttest',
  'url.xboxRegisterReturnUrl': 'http://127.0.0.1/minecrafttest'
});

export const bundleConfig = {
  ...bundleConfigDev,
  'endpoint.minecraftServices': `${host}/`,
  'url.xboxProfile': `${host}`,
  'url.playfabAuth': `${host}/api/v1.0/session/start`,
  'url.playfabEntitles': `${host}/api/v1.0/player/playedtitles`,
  'url.pocketRealmsUrl': `${host}/`,
  'url.pocketRealmsJavaUrl': `${host}/java-realms/`,
  'url.originalPocketRealmsJavaUrl': `${host}/original-java-realms/`,
  'endpoint.entitlementService': `${host}/api/v1.0`,
  'endpoint.paymentService': host,
  'url.xboxPeopleHubUrl': `${host}/`,
  'enable.onestoreWallet': true,
  'url.discoveryService': `https://client.stage-b4c666a2.discovery.minecraft-services.net`,
  'endpoint.net.minecraftServices': host,
  'url.platform2.0IframeURL': host + '/content/minecraftnet/language-masters/en-us/jcr:content.customfooterlibs.html',
  'url.minecoinRefreshLocalOverride': host,
  environmentName: 'Local'
};
